// extracted by mini-css-extract-plugin
export default {"referral-widget":"tq","referral-page":"uq","label":"vq","subHed":"wq","profile-container":"xq","referral-container":"yq","referral-header":"zq","shareMethodRow":"Aq","shareMethod":"Bq","active":"Cq","referral-stat":"Eq","blockwrapper":"Fq","referralLink":"Gq","bold":"Hq","semibold":"Iq","shareAgainButton":"Jq","policy":"Kq","narrowWrapper":"Lq"};
    if(module.hot) {
      // 1730991502237
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  